export const CURRENT_USER_QUERY = '/user';
export const CURRENT_USER_PERMISSIONS_QUERY = '/user/permissions';
